import React, { useState, useEffect } from 'react'

import {
  Panel,
  Row,
  Col,
  ControlLabel,
  Input,
  Form,
  Message,
  InputNumber,
  IconButton,
  Icon,
  SelectPicker,
  Cascader,
} from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import { isValidators, requiredFiled, isRequired } from '../../utils/ValidatorUtils'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'

export default function RoleNameWidget({
  schema: _schema,
  register,
  errors,
  error,
  Controller,
  control,
  setValue,
  clearErrors,
  onSubmit,
  onDelete,
  onChange,
  onChangeMainProject,
  onChangeSubProject,
  onChangeReportDocuments,
  onChangeInstallment,
  disabledValue,
  ...props
}) {
  const { isDeleteError, isError, loading, hideHeader } = props
  const [schema, setSchema] = useState(_schema)
  const [section, setSection] = useState()

  useEffect(() => {}, [])

  return (
    <>
      <Panel
        shaded
        header={schema.header}
        collapsible
        defaultExpanded
        ref={(section) => {
          setSection(section)
        }}
      >
        <Row>
          <Col lg={2} md={4} sm={6} xs={6} style={{ marginTop: '5px', padding: '8px' }}>
            <ControlLabel>
              {requiredFiled(schema.roleNameInput.validators, schema.roleNameInput.label)}
            </ControlLabel>
          </Col>
          <Col lg={22} md={20} sm={18} xs={18} style={{ marginTop: '5px', padding: '8px' }}>
            <ErrorMessage error={errors[schema.roleNameInput.name]} />
            <Input
              name={schema.roleNameInput.name}
              defaultValue={schema.roleNameInput.value}
              inputRef={register(isValidators(schema.roleNameInput.validators))}
            />
          </Col>
        </Row>
      </Panel>
    </>
  )
}
